module.exports = __webpack_public_path__ + "img/0Q3A6289_L_BlackMatted.2c8b0fa3.jpg";